import { Image, Nav, Tab, Table } from "react-bootstrap";
import { Button, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import ItemWrapper from "./ItemWrapper";
import img1 from "../../../../../src/assetsNew/1.jpg";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { backendbaseUrl } from "../../../../Utils/baseUrl";
import { useParams } from "react-router-dom";
import axiosInstance from "../../../../Utils/axiosInstance";
import { toast } from "react-toastify";
import { isString } from "lodash";
import { ArrowUpCircle, Users, ArrowUpRight } from 'lucide-react';
import { useNavigate } from "react-router-dom";

import MyVerticallyCenteredModal from "./centerModal";
import UserCountModal from "./centerModal";
import "./Button4.css";

interface PlanData {
  planName: string;
  PurchaseDate: string;
  ExpiryDate: string;
  DurationInDays: number;
  Total: string;
}
interface organizationType {
  name: string;
  email: string;
  phoneNumber: string;
  defaultCountry: string;
  defaultCurrency: string;
  // planActive: boolean;
  // blocked: boolean;
}

interface UsersDataType {
  name: string;
  email: string;
  phoneNumber: string;
  active: boolean;
  user: string;
}

interface PurchaseHistory {
  name: string;
  startDate: string;
  expiryDate: string;
  isOnlinePurchase: boolean;
  notes: string;
}
interface UserProfileType {
  ordering_id: number;
  created_at: number;
  retrieved_at: number | null;
  name: string;
  email: string;
  phone_number: string;
  is_plan_active: boolean;
  is_blocked: boolean;
  country: string;
  default_currency: string;
  companyId: string;
}

const CompanyDetails = () => {
  const [state, setState] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [planData, setPlanData] = useState<PlanData[]>([]);
  const [organizations, setorganizations] = useState<organizationType[]>([]);
  const [users, setUsers] = useState<UsersDataType[]>([]);
  const [history, setHistory] = useState<PurchaseHistory[]>([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [companyInfo, setCompanyInfo] = useState<any>(false);

  const getPlanStatus = (startDate: string, expiryDate: string): string => {
    const currentDate = new Date();
    const start = new Date(startDate);
    const expiry = new Date(expiryDate);

    return currentDate >= start && currentDate <= expiry ? "Active" : "Expired";
  };

  const blockedHandler: any = async () => {
    try {
      const response = await axiosInstance.post(
        `${backendbaseUrl}/company/block-organization/${id}/`
      );

      console.log(response.data);
    } catch (error: any) { }
  };

  const getRandomColor = (str: string) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    const color = `hsl(${hash % 360}, 70%, 60%)`; // Generates a unique HSL color
    return color;
  };

  const getPlanColors = (plans: PlanData[]) => {
    const colorMap: Record<string, string> = {};

    plans.forEach((plan) => {
      if (!colorMap[plan.planName]) {
        colorMap[plan.planName] = getRandomColor(plan.planName);
      }
    });

    return colorMap;
  };

  const [planColors, setPlanColors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (planData.length > 0) {
      setPlanColors(getPlanColors(planData));
    }
  }, [planData]);


  const [purchaseHistoryData, setPurchaseHistoryData] = useState([])
  useEffect(() => {

    const fetchpurchaseHistory = async () => {
      try {

        const response = await axiosInstance.get(
          `${backendbaseUrl}/company/payments/history/${id}`
        )

        if (response.status == 200) {
          setPurchaseHistoryData(response.data)
          // console.log("data,", response.data)
          // console.log("fetchpurchaseHistory", purchaseHistoryData)
        }

      }
      catch (error) {

        toast.error(isString(error))

      }

    }

    fetchpurchaseHistory()

  }, [])



  const [loginhistory, setLoginhistory] = useState([])
  useEffect(() => {

    const fetchloginhistory = async () => {
      try {

        const response = await axiosInstance.get(
          `${backendbaseUrl}/company/company-users/history/${id}`
        )

        if (response.status == 200) {
          setLoginhistory(response.data)
          console.log("data,", response.data)
          // console.log("fetchpurchaseHistory", purchaseHistoryData)
        }

      }
      catch (error) {

        toast.error(isString(error))

      }

    }

    fetchloginhistory()

  }, [])

  const checkPaymentStatus = async () => {
    try {
      // const id = "1f95379d-dcd9-41ab-af1e-b6d2921f4753";

      const response = await axiosInstance.get(
        `${backendbaseUrl}/company/organization/${id}`
      );

      const currentPlan = response.data.current_plan;
      const organizationDetails = response.data.organization_details;
      const userData = response.data.users;
      const history = response.data.purchase_history;
      const companys = response.data;
      const companyId = response.data.id


      // if (!currentPlan) return;

      const formattedPlan: PlanData[] = [
        {
          planName: currentPlan.plan_name || "Unknown Plan",
          PurchaseDate: currentPlan.purchase_date || "N/A",
          ExpiryDate: currentPlan.expiry_date || "N/A",
          DurationInDays: currentPlan.remaining_days || 0,

          Total: `${currentPlan.total_users || 0}/${currentPlan.max_users || 0
            }`,
        },
      ];

      const formattedOrganizations: organizationType[] = [
        {
          name: organizationDetails.name || "Unknown Org",
          email: organizationDetails.email || "N/A",
          phoneNumber: organizationDetails.phone_number || "N/A",
          defaultCountry: organizationDetails.default_country || "N/A",
          defaultCurrency: organizationDetails.default_currency || "N/A",
          // planActive: organizationDetails.is_plan_active || "N/A",
          // blocked: organizationDetails.is_blocked || "N/A",
        },
      ];

      const formattedUsers: UsersDataType[] = userData.map((user: any) => ({
        name: user.name || "N/A",
        email: user.email || "N/A",
        phoneNumber: user.phone_number || "N/A",
        active: user.is_active ?? false,
        user: user.user_type || "N/A",
      }));

      const formattedHistory: PurchaseHistory[] = history.map((item: any) => ({
        name: item.plan_name || "N/A",
        startDate: item.start_date || "N/A",
        expiryDate: item.expiry_date || "N/A",
        isOnlinePurchase: item.is_online_purchase ?? false,
        notes: item.notes
      }));

      const companysData: UserProfileType = {
        ordering_id: companys.id,
        created_at: companys.created_at,
        retrieved_at: companys.retrieved_at,
        name: companys.name,
        email: companys.email,
        phone_number: companys.phone_number,
        is_plan_active: companys.is_plan_active,
        is_blocked: companys.is_blocked,
        country: companys.country,
        default_currency: companys.default_currency,
        companyId: companyId
      };
      console.log("companysData", companysData, "companysData")
      setPlanData(formattedPlan);
      setorganizations(formattedOrganizations);
      setUsers(formattedUsers);
      setHistory(formattedHistory);
      setCompanyInfo(companysData);
      setState(userData.is_blocked);
    } catch (error: any) {
      console.log("error");
    }
  };

  useEffect(() => {
    checkPaymentStatus();
  }, []);

  const formatDate = (timestamp: number) => {
    return new Date(timestamp * 1000).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  return (
    <div className="page-body">
      <Container fluid>
        <div className="companyProfileWrapper">
          <Row>
            <Col md={3}>
              <ItemWrapper>
                <div className="companyProfile">
                  {companyInfo ? (
                    <>
                      {/* Profile Image & Name */}
                      <div className="text-center companyProfile_brand mb-5">
                        <div className="companyProfile_brand_info m-auto">
                          <Image
                            src={img1}
                            alt="Company Logo"
                            className="h-100 object-fit-cover w-100 text-center"
                          />
                        </div>
                        <h3 className="mt-3 fw-semibold">{companyInfo.name}</h3>
                      </div>

                      {/* Profile Details */}
                      <div className="companyProfile_details">
                        <ul>
                          <li className="mb-3">
                            <label className="mb-0">Email</label>
                            <p className="fw-semibold">
                              {companyInfo.email || "N/A"}
                            </p>
                          </li>
                          <li className="mb-3">
                            <label className="mb-0">Phone</label>
                            <p className="fw-semibold">
                              {companyInfo.phone_number || "N/A"}
                            </p>
                          </li>
                          <li className="mb-3">
                            <label className="mb-0">Created</label>
                            <p className="fw-semibold">
                              {formatDate(companyInfo.created_at)}
                            </p>
                          </li>
                          <li className="mb-3">
                            <label className="mb-0">Status</label>
                            <div className="align-items-center d-flex flex-wrap justify-content-between">
                              <div
                                className="align-items-center d-flex"
                                style={{ gap: ".5rem" }}
                              >
                                <span
                                  className={
                                    companyInfo.is_blocked
                                      ? "user-blocked"
                                      : "user-active"
                                  }
                                ></span>
                                {companyInfo.is_blocked ? "Blocked" : "Active"}
                              </div>


                              <div>
                                <Form>
                                  <FormGroup switch>
                                    <Input
                                      type="switch"
                                      checked={companyInfo.is_blocked}
                                      onClick={() => blockedHandler()}
                                      onChange={(e) =>
                                        setCompanyInfo({
                                          ...companyInfo,
                                          is_blocked: e.target.checked,
                                        })
                                      }
                                    />
                                    <Label check>Disable/Enable</Label>
                                  </FormGroup>
                                </Form>
                              </div>
                            </div>
                          </li>


                          <div className="flex justify-center gap-4 mt-4" style={{ display: 'flex' }}>
                            <button className="custom-btn btn-12" onClick={() => { navigate(`/settings/company/upgrade-plan/${companyInfo.companyId}`) }}>

                              <span>Upgrade</span><span>Upgrade Plan </span>
                            </button>

                            <div className="gap-2">
                              {/* <button className="custom-btn btn-7" onClick={() => { navigate(`/settings/company/upgrade-user/${companyInfo.companyId}`) }}> */}

                              <button className="custom-btn btn-7" onClick={() => setModalShow(true)}>
                                <span>Upgrade User</span>
                              </button>
                            </div>
                          </div>
                          <UserCountModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            companyId={companyInfo.companyId}
                          />
                        </ul>
                      </div>
                    </>
                  ) : (
                    <p>Loading...</p>
                  )}
                </div>
              </ItemWrapper>
            </Col>
            <Col md={9}>
              <ItemWrapper>
                <div className="companyProfile_organization">
                  <Tab.Container defaultActiveKey="active">
                    <Nav variant="tabs">
                      <Nav.Item>
                        <Nav.Link eventKey="active">Plan</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="users">Users</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="details">Details</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="history">History</Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link eventKey="paymenthistory">Payment History</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="loginHistory">Login History</Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content>
                      <Tab.Pane eventKey="active">
                        <Table
                          responsive
                          hover
                          striped
                          bordered
                          className="align-middle mt-3 shadow-sm"
                        >
                          <thead className="table-dark text-center">
                            <tr>
                              <th>Sl/No</th>
                              <th>Plans</th>
                              <th>Purchase Date</th>
                              <th>Expiry Date</th>
                              <th>Duration (Days)</th>
                              <th>Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            {planData.map((plan, index) => (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">
                                  <span
                                    className=" text-white badge"
                                    style={{
                                      backgroundColor: planColors[plan.planName],
                                    }}
                                  >
                                    {plan.planName}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-primary">
                                    {plan.PurchaseDate}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-danger">
                                    {plan.ExpiryDate}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-success">
                                    {plan.DurationInDays}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-warning text-white">
                                    {plan.Total}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Tab.Pane>
                      <Tab.Pane eventKey="users">
                        <Table
                          responsive
                          hover
                          striped
                          bordered
                          className="align-middle mt-3 shadow-sm"
                        >
                          <thead className="table-dark text-center">
                            <tr>
                              <th>Sl/No</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone Number</th>
                              <th>User</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {users.map((user, index) => (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{user.name}</td>
                                <td className="text-center">
                                  <span className="badge bg-primary">
                                    {user.email}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-secondary">
                                    {user.phoneNumber}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-success">
                                    {user.user}
                                  </span>
                                </td>
                                <td className="text-center d-flex align-items-center justify-content-center gap-2">
                                  <span
                                    className={`rounded-circle d-inline-block`}
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      backgroundColor: user.active
                                        ? "#28a745"
                                        : "#dc3545",
                                    }}
                                  ></span>
                                  <span
                                    className={
                                      user.active ? "text-success" : "text-danger"
                                    }
                                  >
                                    {user.active ? "Active" : "Inactive"}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Tab.Pane>
                      <Tab.Pane eventKey="details">
                        <Table
                          responsive
                          hover
                          striped
                          bordered
                          className="align-middle mt-3 shadow-sm"
                        >
                          <thead className="table-dark text-center">
                            <tr>
                              <th>Sl/No</th>
                              <th>Organization Name</th>
                              <th>Email</th>
                              <th>Phone Number</th>
                              <th>Default Country</th>
                              <th>Default Currency</th>
                            </tr>
                          </thead>
                          <tbody>
                            {organizations.map((org, index) => (
                              <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{org.name}</td>
                                <td className="text-center">
                                  <span className="badge bg-primary">
                                    {org.email}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-secondary">
                                    {org.phoneNumber}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-success">
                                    {org.defaultCountry}
                                  </span>
                                </td>
                                <td className="text-center">
                                  <span className="badge bg-warning text-dark">
                                    {org.defaultCurrency}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Tab.Pane>
                      <Tab.Pane eventKey="history">
                        <Table responsive
                          hover
                          striped
                          bordered className="align-middle mt-3 shadow-sm">
                          <thead className="table-dark text-center">
                            <tr>
                              <th>Sl/No</th>
                              <th>Plane Name</th>
                              <th>Plan Start Date</th>
                              <th>Plan Expiry Date</th>
                              <th>Status</th>
                              <th>Notes</th>
                            </tr>
                          </thead>
                          <tbody>
                            {history.map((plan, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="text-center">
                                    <span className={`text-white badge`} style={{
                                      backgroundColor: planColors[plan.name],
                                    }}>
                                      {plan.name}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="badge bg-primary">
                                      {plan.startDate}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="badge bg-secondary">
                                      {plan.expiryDate}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <div className="align-items-center d-flex gap-2 justify-content-center">
                                      <span
                                        className={`plan-outline plan-active_white  ${getPlanStatus(
                                          plan.startDate,
                                          plan.expiryDate
                                        ) === "Active"
                                          ? "plan-active"
                                          : "plan-expired"
                                          }`}
                                      ></span>
                                      <span>
                                        {getPlanStatus(
                                          plan.startDate,
                                          plan.expiryDate
                                        )}
                                      </span>
                                      <br></br>

                                    </div>
                                  </td>
                                  <td className="text-center">
                                    <span className="badge bg-primary">
                                      {plan.notes ?? "-"}
                                    </span>
                                  </td>
                                </tr>
                              </React.Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </Tab.Pane>
                      <Tab.Pane eventKey="paymenthistory">
                        <Table responsive
                          hover
                          striped
                          bordered className="align-middle mt-3 shadow-sm">
                          <thead className="table-dark text-center">
                            <tr>
                              <th>Date</th>
                              <th>Payment status</th>
                              <th>Session Id</th>
                              <th>Track ID </th>
                              <th>Datas Submited</th>
                              <th>Error data</th>
                              <th>Plan Details</th>

                            </tr>
                          </thead>
                          <tbody>
                            {purchaseHistoryData.map((purchase: any, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td className="text-center">
                                    <span>
                                      {purchase.created_at}
                                    </span>
                                  </td>
                                  <td className={"text-center"}>{purchase.payment_status ? "🟢paid" : "🔴not paid"}</td>

                                  <td className="text-center">
                                    <span>
                                      {purchase.session_id}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span className="badge bg-primary">
                                      {purchase.track_id}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <table className="table-auto text-sm border border-gray-300 mx-auto">
                                      <tbody>
                                        {Object.entries(purchase.formdata || {})
                                          .filter(([key]) => key !== "countrySelect")
                                          .map(([key, value]) => (
                                            <tr key={key}>
                                              <td className="border border-black px-2 py-1 font-semibold">{key}</td>
                                              <td className="border border-black px-2 py-1">{String(value)}</td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </td>
                                  <td className="text-center">
                                    <table className="table-auto text-sm border border-gray-300 mx-auto">
                                      <tbody>
                                        {Object.entries(purchase.errors || {}).map(([key, value]) => (
                                          <tr key={key}>
                                            <td className="border border-black px-2 py-1 font-semibold">{key}</td>
                                            <td className="border border-black px-2 py-1">{String(value)}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </td>
                                  <td className="text-center">
                                    <table className="table-auto text-sm border border-gray-300 mx-auto">
                                      <tbody>
                                        {Object.entries(purchase.plan || {})
                                          .filter(([key]) => key !== "id" && key !== "country" && key !== "created_at")
                                          .map(([key, value]) => (
                                            <tr key={key}>
                                              <td className="border border-black px-2 py-1 font-semibold">{key}</td>
                                              <td className="border border-black px-2 py-1">{String(value)}</td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </td>

                                </tr>
                              </React.Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </Tab.Pane>

                      <Tab.Pane eventKey="loginHistory">
                        <Table responsive
                          hover
                          striped
                          bordered className="align-middle mt-3 shadow-sm">
                          <thead className="table-dark text-center">
                            <tr>
                              <th>Date</th>
                              <th>email</th>
                              <th>Error status</th>
                              <th>IP Address</th>
                              <th>Message</th>
                              <th>Meta Data</th>


                            </tr>
                          </thead>
                          <tbody>
                            {loginhistory.map((loginhistory: any, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td className="text-center">
                                    <span>
                                      {loginhistory.created_at}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span>
                                      {loginhistory.user}
                                    </span>
                                  </td>
                                  <td className={"text-center"}>{loginhistory.error_status ? "🔴error " : "🟢 no error"}</td>

                                  <td className="text-center">
                                    <span>
                                      {loginhistory.ip_address}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span>
                                      {loginhistory.message}
                                    </span>
                                  </td>

                                  <td className="text-center">
                                    <table className="table-auto text-sm border border-gray-300 mx-auto">
                                      <tbody>
                                        {Object.entries(loginhistory.metadata || {})
                                          .filter(([key]) => key !== "countrySelect")
                                          .map(([key, value]) => (
                                            <tr key={key}>
                                              <td className="border border-black px-2 py-1 font-semibold">{key}</td>
                                              <td className="border border-black px-2 py-1">{String(value)}</td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </td>

                                </tr>
                              </React.Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </ItemWrapper>
            </Col>
          </Row>
        </div>
      </Container >

    </div >



  );
};

export default CompanyDetails;
